import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import GenericContainer from '../../components/@container/generic-container';
import Link from '../../components/link';

const ResourcesPage: NextPage = () => (
  <Layout title="Resources">
    <GenericContainer
      title="Resources"
      breadcrumb={{ url: '/', text: 'Back to home' }}
    >
      <div className="content">
        <p>Please choose one of the following options.</p>
        <div className="resources">
          <Link href="/resources/child-safety-information">
            <a className="resource-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              Child Safety Info
            </a>
          </Link>
          <Link href="/resources/vin-decoder">
            <a className="resource-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              VIN Decoder
            </a>
          </Link>
          <Link href="/resources/workshop-support-platform">
            <a className="resource-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              Workshop Support Platform
            </a>
          </Link>
          <Link href="/resources/mode-06">
            <a className="resource-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              Mode $06
            </a>
          </Link>
          <Link href="https://cdn.volvotechinfo.com/resources/SMB00-013-2021-11-04.pdf">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Vehicle Type & Platform Information
          </Link>
          <Link href="https://cdn.volvotechinfo.com/resources/ServiceActionsList-02.22.2022.pdf">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Service Action List
          </Link>
          <Link href="https://volvoretailersolutions.com/">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Dealer Equipment
          </Link>
          <Link href="https://collection.volvocars.com/en">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Volvo Collection
          </Link>
          <Link href="https://automotivetechinfo.com/volvo-techtips/">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Volvo TechTips Magazine
          </Link>
          <Link href="https://cdn.volvotechinfo.com/resources/VOL_RoadHazard_ConsumerBrochure_7-25x8-5_VAR12_TERMS and CONDITIONS_ONLY.pdf">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            Tire Advantage Program - Terms and Conditions
          </Link>
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        p {
          font-family: 'Volvo Novum', sans-serif;
        }

        .resources {
          display: grid;
          align-items: center;
        }

        .resource-tile,
        .resources > :global(a) {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          text-decoration: none;
          color: #333;
          padding: 1rem;
          margin-bottom: 0.5rem;
          cursor: pointer;
        }

        .resource-tile:hover,
        .resources > :global(a:hover) {
          background-color: #eee;
        }

        .click-icon {
          float: left;
          padding-right: 2rem;
        }
      `}</style>
    </GenericContainer>
  </Layout>
);

export default ResourcesPage;
